export const LOADOUT_STATUS = [
  { value: 0, label: 'No Infomation Provided' },
  { value: 1, label: 'Loadout Ready To Send' },
  { value: 2, label: 'Loadout Needs Revisions' },
  { value: 3, label: 'Pending Artist Review' },
  { value: 4, label: 'Loadout Finalized' },
]

export const LOADOUT_STATUS_OPTIONS = [
  'all',
  'link products',
  'build loadout',
  'saved',
  'submitted',
  'needs revisions',
  'accepted',
];

export const PROJECT_STATUS_OPTIONS = [
  'all',
  'initialized',
  'in progress',
  'completed',
];

export const STORE_PLATFORM_OPTIONS = [
  'all',
  'shopify',
  'bigcommerce',
  'levar'
];

// OLD Subscription Plans
// export const SUBSCRIPTION_PLANS = [
//   [
//     "STARTER",
//     "$59/month",
//     "3D/AR",
//     "3D Configurator & Augmented Reality",
//     "No code implementation",
//     "Upload your own 3D Models",
//     "Email & SMS API",
//     "Unlimited Views",
//     "Up to 20 Models"
//   ],
//   [
//     "ESSENTIALS",
//     "$99/month",
//     "3D/AR",
//     "3D Configurator & Augmented Reality",
//     "No code implementation",
//     "API to Email / SMS / Integrations",
//     "4k/HD quality",
//     "Animation",
//     "Up to 40 Models"
//   ],
//   [
//     "PRO",
//     "$249/month",
//     "Everything in Essentials",
//     "White Glove Onboarding",
//     "Custom CTA",
//     "3D / AR Spotlight Viewer",
//     "1000% ROI Guarantee",
//     "Simple Sharing API",
//     "Up to 100 Models"
//   ]
// ];

// 2025 Subscription Plans - Updated format for better maintainability
export const SUBSCRIPTION_PLANS = [
  {
    id: 'free',
    title: 'FREE',
    price: 0,
    priceDisplay: '$0/month',
    features: [
      '3D/AR',
      '3D & Augmented Reality',
      'No code implementation',
      'Upload your own 3D Models',
      'Email & SMS API',
      'Unlimited Views',
    ],
    modelLimit: 1,
    modelLimitDisplay: '1 Free (Upload your own)'
  },
  {
    id: 'starter',
    title: 'STARTER',
    price: 59,
    priceDisplay: '$59/month',
    features: [
      '3D/AR',
      '3D & Augmented Reality',
      'No code implementation',
      'Upload your own 3D Models',
      'Email & SMS API',
      'Unlimited Views',
    ],
    modelLimit: 20,
    modelLimitDisplay: 'Up to 20 Models'
  },
  {
    id: 'essentials',
    title: 'ESSENTIALS',
    price: 99,
    priceDisplay: '$99/month',
    features: [
      '3D/AR',
      '3D & Augmented Reality',
      'No code implementation',
      'Upload your own 3D Models',
      'Email & SMS API',
      'Unlimited Views',
    ],
    modelLimit: 40,
    modelLimitDisplay: 'Up to 40 Models'
  },
  {
    id: 'pro',
    title: 'PRO',
    price: 249,
    priceDisplay: '$249/month',
    features: [
      'Everything in Starter',
      'Custom CTA',
      '3D / AR Spotlight Viewer',
      'Simple Sharing API',
      '4k/HD quality',
      'Unlimited Views',
    ],
    modelLimit: 100,
    modelLimitDisplay: 'Up to 100 Models'
  },
  {
    id: 'enterprise',
    title: 'ENTERPRISE',
    price: 499,
    priceDisplay: '$499/month',
    features: [
      'Dedicated Success Agent',
      'Custom 3D/AR Configurator',
      'Virtual Try On',
      '3D Search & Ads',
      'Custom AR Marketing',
      'Unlimited Views',
    ],
    modelLimit: null,
    modelLimitDisplay: 'Custom # of Models',
    isEnterprise: true
  }
];

// 2024 && 2025 MASTER MODEL ID's
export const LEVAR_3D_MODEL_ID_TYPES = {
  model_3d_id: "",
  interactive_viewer_0: "",
  static_viewer_0: "",
  static_vto_face_0: "",
  interactive_vto_face_0: "",
  interactive_absolute_ground_0: "",
  interactive_absolute_wall_0: "",
  interactive_absolute_lighting_0: "",
  room_viewer_0: "",
}

// 2024
export const LEVAR_ECOMM_VARIANT_DEFAULT_RESET = {
  ar_experience_type: false, // null
  asset_theme: false, // null
  billboard_status: false, 
  custom_button: false,
  direct_qr: false,
  pdp_variant_switch: false,
  preload_viewer: false,
  translation_inactive: false,
  view_in_space_off: false,
  ...LEVAR_3D_MODEL_ID_TYPES
};

// variant Implementation Template
// export const ECOM_VARIANT_IMPLEMENTATION_TEMPLATE = {
//   ar_experience_type: null, // levar_try_on || null
//   asset_theme: null, // "levar_debut" || "levar_player" || null
//   billboard_status: false, 
//   custom_button: false, // true || false
//   direct_qr: false, // true || false
//   pdp_variant_switch: false,
//   preload_viewer: false,
//   translation_inactive: false, // true || false
//   view_in_space_off: false,
// };

// vList Implementation Template
export const V_LIST_IMPLEMENTATION_TEMPLATE = {
  ar_experience_type: null, // levar_try_on || null
  asset_theme: null, // "levar_debut" || "levar_player" || null
  billboard_list: null, 
  billboard_status: false, 
  custom_button: false, // true || false
  custom_text: null,
  direct_qr: false, // true || false
  levar_exit_url: null, 
  pdp_variant_switch: false,
  preload_viewer: false,
  translation_inactive: false, // true || false
  view_in_space_off: false,
};

// 2024 IMPLEMENTATION DISPLAY NAMES
export const IMPLEMENTATION_NAMES = {
  direct_qr: 'Direct QR Button',
  asset_theme: '3D Button',
  translation_inactive: 'Translation Off'
};

// 2024 DEFAULT Store Implementation Template
export const IMPLEMENTATION_STORE_DEFAULTS = {
  asset_theme: false, // "levar_debut" || "levar_player" || null
  direct_qr: false, // true || false (Modal)
  translation_inactive: false, // true || false
};

// 2024 Store Implementation Template
export const IMPLEMENTATION_STORE_DEFAULTS_FOR_CHECK = {
  asset_theme: null, // "levar_debut" || "levar_player" || null
  direct_qr: false, // true || false (Modal)
  translation_inactive: false, // true || false
};

// 2024 values for implementation Store Possible Implementation Values
export const IMPLEMENTATION_VALUES = {
  asset_theme: [
    {
      value: true,
      label: 'On',
    },
    {
      value: false,
      label: 'Off',
    }
  ],
  // asset_theme: [
  //   {
  //     value: '',
  //     label: 'RESET',
  //   },
  //   {
  //     value: 'levar_player',
  //     label: 'Player',
  //   },
  //   {
  //     value: 'levar_debut',
  //     label: 'Debut (Deprecated)',
  //   }
  // ],
  direct_qr: [
    {
      value: true,
      label: 'On',
    },
    {
      value: false,
      label: 'Off',
    }
  ]
};

// 2024 Implementation help information
export const IMPLEMENTATION_HELP = {
  asset_theme: {
    description: 'The 3D Button allows customers to view your products with custom 3D button',
    helpLink: 'https://mac-scot-stuff.myshopify.com/products/standard-3d-custom-code',
    exampleLink: 'https://mac-scot-stuff.myshopify.com/products/standard-3d-custom-code'
  },
  direct_qr: {
    description: 'Direct QR Button enables customers to quickly access AR view via QR code',
    helpLink: 'https://docs.levar.io/docs/direct-qr',
    exampleLink: 'https://mac-scot-stuff.myshopify.com/products/standard-activation-custom-install'
  },
  translation_inactive: {
    description: 'Control whether translation features are active for your 3D experiences',
    helpLink: false,
    exampleLink: false
  }
};